import _ from 'lodash'
import api from '@/api'
import types from './types'
import handleError from '@/lib/handleError.js'
import { serializeQuickAction } from './serializer'

export default {
  async getRev(context, { organizationId, revId }) {
    const rev = await api.quickaction
      .getById(organizationId, revId)
      .then(response => response.data)

    context.commit(types.SET_REV, { rev })
    return rev
  },

  create(context, { organizationId, data }) {
    return api.quickaction
      .create(organizationId, data)
      .then(({ data: rev }) => {
        context.commit('SET_REV', { rev })
        return { revId: rev.id }
      })
  },

  async update(context, { organizationId, revId, data }) {
    const quickAction = await api.quickaction
      .update(organizationId, revId, serializeQuickAction(data))
      .then(response => response.data)

    const rev = quickAction
    context.commit(types.SET_REV, rev)

    return { revId }
  },

  delete(context, { organizationId, revId }) {
    return api.quickaction.delete(organizationId, revId)
  },

  like(context, payload) {
    const { organizationId, revId } = payload
    return api.like
      .add(organizationId, 'quick-actions', revId)
      .then(() => api.quickaction.getById(organizationId, revId))
      .then(({ data: rev }) => {
        context.commit(types.SET_REV, { rev })
        context.dispatch('refreshAccountData', {}, { root: true })
        return rev
      })
      .catch(handleError)
  },

  unlike(context, payload) {
    const { organizationId, revId } = payload
    return api.like
      .remove(organizationId, 'quick-actions', revId)
      .then(() => api.quickaction.getById(organizationId, revId))
      .then(({ data: rev }) => {
        context.commit(types.SET_REV, { rev })
        return rev
      })
      .catch(handleError)
  },

  approveRev: function (context, payload) {
    return api.approvals
      .add(payload.organizationId, 'quick-actions', payload.revId)
      .then(() => {
        return api.quickaction.getById(payload.organizationId, payload.revId)
      })
      .then(({ data: rev }) => {
        context.commit(types.SET_REV, { rev })

        context.dispatch('refreshAccountData', {}, { root: true })
        return rev
      })
      .catch(handleError)
  },

  disapproveRev: function (context, payload) {
    return api.approvals
      .remove(
        payload.organizationId,
        'quick-actions',
        payload.revId,
        payload.approvalId
      )
      .then(() => {
        return api.quickaction.getById(payload.organizationId, payload.revId)
      })
      .then(({ data: rev }) => {
        context.commit(types.SET_REV, { rev })

        return rev
      })
      .catch()
  },

  async translateRev(
    context,
    { organizationId, revId, targetLanguage, fieldsToTranslate }
  ) {
    const { data: rev } = await api.quickaction.getById(organizationId, revId)

    const translatedRev = Object.assign({}, rev)

    for (const field of fieldsToTranslate) {
      if (!_.get(rev, field)) continue
      const translatedField = await api.translate.text(
        organizationId,
        _.get(rev, field),
        targetLanguage
      )
      _.set(translatedRev, field, translatedField.data.translatedText)
    }

    context.commit(types.SET_REV, translatedRev)

    return translatedRev
  },

  async validationRequest(context, payload) {
    const response = await api.validationRequest.add(
      payload.organizationId,
      'quick-actions',
      payload.revId,
      payload.assignees
    )
    return response
  },

  async updateRequestStatus(context, payload) {
    return await api.validationRequest.update(
      payload.organizationId,
      'quick-actions',
      payload.revId,
      payload.requestId,
      payload.status
    )
  },
}
